// import axiosClient from "./request";
export const API_URL =
// "https://api.laundrygo.com.au/v1" // prod
// "https://laundryapp.24livehost.com/v1"     //live
// "https://laundrygoapps.24livehost.com/v1";     dev
"https://api.laundrygo.com.au/v1";    //uat
